export default __webpack_public_path__ + "static/Hishmat-Rai-c6f22b39f805fb45f0e19b1f225d2818.png";